<template>
  <div>
    <p class="title is-5">
      Report Type
    </p>
    <section>
      <b-field class="radio-tabs">
        <b-radio
          v-model="reportType"
          native-value="impact"
          type="is-primary"
          v-on:input="doCallback"
        >
          <span>Impact</span>
        </b-radio>
      </b-field>

      <b-field class="radio-tabs">
        <b-radio
          v-model="reportType"
          native-value="metaphor"
          v-on:input="doCallback"
          v-bind:disabled="!$root.advisor.hasFeature('Metaphor Metrics')"
        >
          <b-tooltip
            label="You need to upgrade your account to access Metaphor reports."
            v-bind:active="!$root.advisor.hasFeature('Metaphor Metrics')"
          >
            <span>
              Metaphor
            </span>
          </b-tooltip>
        </b-radio>
      </b-field>

      <b-field class="radio-tabs">
        <b-radio
          v-model="reportType"
          native-value="institutional"
          v-on:input="doCallback"
          v-bind:disabled="!$root.advisor.hasFeature('Institutional Report')"
        >
          <b-tooltip
            label="You need to upgrade your account to access this report type."
            v-bind:active="!$root.advisor.hasFeature('Institutional Report')"
          >
            <span>
              Institutional
            </span>
          </b-tooltip>
        </b-radio>
      </b-field>

      <b-field class="radio-tabs">
        <b-radio
          v-model="reportType"
          native-value="persona"
          v-on:input="doCallback"
          v-if="$root.advisor.hasFeature('Persona Report')"
        >
          <span>
            Persona
          </span>
        </b-radio>
      </b-field>
      <br>
      <p v-if="reportType">
        <div
          v-for="(style, index) in types[reportType]"
          v-bind:key="`${reportType}-${style.name}`"
        >
          <b-radio
            v-model="reportStyle[reportType]"
            v-bind:name="reportType"
            v-bind:native-value="style.name"
            v-on:input="doCallback"
          >
            <strong>{{ style.friendly_name }}</strong>
            <br>
            <small>{{ style.description }}</small>
          </b-radio>
          <br>
          <br>
        </div>
      </p>
    </section>
  </div>
</template>

<script>
  import { apiFetch } from '../../../api/api';

  export default {
    data() {
      return {
        reportType: 'impact',
        reportStyle: {
          metaphor: 'minimal',
          impact: 'minimal',
          institutional: 'base',
          persona: 'base',
        },
        types: {},
      }
    },
    components: {},
    methods: {
      doCallback: function() {
        const { reportType, reportStyle, types, selectedType, callback } = this;
        const style = reportStyle?.[reportType];
        console.log(reportType, style);

        if (types && reportType in types) {
          const match = types[reportType].find(itm => itm?.name === style);

          if (match) {
            callback?.call(this, selectedType, reportType, style, match);
          } else {
            console.warn(`No matching item found for style "${style}" in types["${reportType}"]`);
          }
        } else {
          console.warn(`reportType "${reportType}" not found in types`);
        }
      }
    },
    props: {
      callback: Function
    },
    computed: {
      selectedType: function() {
        return this.types[this.reportType];
      }
    },
    watch: {
      selectedType: function() {
        this.$emit('input', this.selectedType);
      }
    },
    created: function() {
      apiFetch('/api/v1/report_styles/')
        .then((data) => {
          return data.json();
        })
        .then((data) => {
          this.types = data;

          let urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('reportType')) {
            this.reportType = urlParams.get('reportType');
            if (urlParams.get('reportStyle')) {
              this.reportStyle[this.reportType] = urlParams.get('reportStyle');
            }
          }
          this.$nextTick(() => {
            this.doCallback();
          });
        });
    },
  }
</script>

<style scoped>
.radio-tabs {
  margin-bottom: 0.25rem !important;
}
</style>
